import { GithubIssueStatus, GithubIssueStatusColor } from '../types/github.types';

const colorByStatus: Record<GithubIssueStatus, GithubIssueStatusColor> = {
  open: GithubIssueStatusColor.OPEN,
  closed: GithubIssueStatusColor.CLOSED,
};
export const getColorByGithubStatus = (status: GithubIssueStatus): GithubIssueStatusColor => colorByStatus[status];
